export const validateOptions = (name, text, regExValidation, language) => {
  const regEx = new RegExp(regExValidation);
  if (!regEx.test(text)) {
    return `${language?.InvalidExtraField} ${name.toLowerCase()}`;
  }
  return false;
};
